import React from 'react';
import PropTypes from 'prop-types';
// import { InputContainer } from '../Form/FormElements.styles';
import { FieldContainer } from '../Form/Input.styles';
import { tags } from '../../OnlineTraining/CourseLists/SearchDetails/SearchBar/Tags';

const SelectIndustry = ({
  value,
  nestedValue,
  upperValue,
  containerClassName,
}) => {
  const industryOptions = tags.filter((tag) => tag.id !== 'all');

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    nestedValue({
      ...upperValue,
      industry: selectedValue,
    });
  };

  return (
    <FieldContainer className={containerClassName}>
      <label htmlFor="industry">Select Industry:</label>

      <select id="industry" value={value || ''} onChange={handleChange}>
        <option value="" disabled>
          -- Select an Industry --
        </option>
        {industryOptions.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </FieldContainer>
  );
};

SelectIndustry.propTypes = {
  value: PropTypes.string,
  nestedValue: PropTypes.func,
  upperValue: PropTypes.object,
  containerClassName: PropTypes.string,
};

export default SelectIndustry;
